export const initialState = {
  name: '',
};

export const getCompanyName = (state = initialState) => state.name;



// WEBPACK FOOTER //
// ./src/store/company/selectors.js